import React from "react";
import * as $ from 'jquery'
import FilePreview from './FilePreview'

// Same expand-on-click pattern as FilesUpload (embed works for image + pdf)
export const PreviewableImage = (props) => {
  const { image, className, style, wrapperClassName = 'mb-6', wrapperStyle } = props
  const imageUrl = image?.file?.url || image?.file
  if (!imageUrl) return null

  const previewId = image.id || image.byte_size

  const openPreview = (e) => {
    e.preventDefault()
    $(`#file-preview-${previewId}`).modal('show')
  }

  return (
    <div className={wrapperClassName} style={wrapperStyle}>
      <label className="btn p-0 m-0" onClick={openPreview} style={{ cursor: 'pointer' }}>
        <embed
          className={className}
          style={{ ...(style || { objectFit: 'fit' }), pointerEvents: 'none' }}
          src={imageUrl}
        />
      </label>
      <FilePreview id={previewId} imageUrl={imageUrl} />
    </div>
  )
}

export default PreviewableImage
